// extracted by mini-css-extract-plugin
export var boxItems = "_8d-1";
export var boxItemsLg = "_8d-2";
export var button = "_8d-7";
export var buttonHoverless = "_8d-9";
export var buttonLg = "_8d-8";
export var filterGroupBox = "_8d-0";
export var icon = "_8d-3";
export var iconSecondary = "_8d-6";
export var iconWrapper = "_8d-4";
export var iconWrapperLg = "_8d-5";
export var truncatedLabel = "_8d-a";